import React from 'react';

const AsyncAuthorPage = React.lazy(() => import('./AuthorContainer'));

export const AuthorPage = () => {
  return <AsyncAuthorPage />;
};
